import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { SCREEN } from 'scenes/common/types/screen';

export const PriceWrapper = styled.div`
  font-size: 2rem;
  font-weight: 900;
  text-align: right;
  span:first-of-type {
    font-weight: 400;
  }

  span:nth-child(odd) {
    font-size: 45%;
    vertical-align: super;
  }
`;

export const HeaderPriceWrapper = styled.div`
  @media (min-width: ${SCREEN.SMALL}px) {
    font-size: 3rem;
    line-height: 40px;
  }
  sup {
    vertical-align: revert;
    font-size: 50%;
  }
`;

const SidebarPrice = styled.div`
  @media (min-width: ${SCREEN.SMALL}px) {
    font-size: 3.5rem;
    line-height: 2.5rem;
    text-align: right;
  }
  sup {
    vertical-align: revert;
    font-size: 50%;
  }
`;

const PremiumPrice: FunctionComponent<{
  amount: string;
  footnoteSymbol?: string;
}> = ({ amount, footnoteSymbol }) => {
  const [wholeNumber, decimals] = Number(amount).toFixed(2).split('.');
  return (
    <>
      <span>$</span>
      <span>{wholeNumber}</span>
      <span>.{decimals}</span>
      {footnoteSymbol && <sup>&nbsp;{footnoteSymbol}</sup>}
    </>
  );
};

interface PriceProps {
  amount: string;
  footnoteSymbol?: string;
  sidebarDisplay?: boolean;
}

export const Price: FunctionComponent<PriceProps> = ({
  amount,
  footnoteSymbol,
  sidebarDisplay,
}) => (
  <PriceWrapper>
    {sidebarDisplay ? (
      <SidebarPrice>
        <PremiumPrice amount={amount} footnoteSymbol={footnoteSymbol} />
      </SidebarPrice>
    ) : (
      <HeaderPriceWrapper>
        <PremiumPrice amount={amount} footnoteSymbol={footnoteSymbol} />
      </HeaderPriceWrapper>
    )}
  </PriceWrapper>
);

export default Price;
